var Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    defaults: {
        hideActivityNotes: true //separate from viewer default b/c this could later be sep module -- maybe pull from a config file for both
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/settings.js
 ** module id = 273
 ** module chunks = 0
 **/